export { default } from './MosaicDestacatText';
